import { render, staticRenderFns } from "./FileDownloadCard.vue?vue&type=template&id=13c2ccec&scoped=true&"
import script from "./FileDownloadCard.vue?vue&type=script&lang=js&"
export * from "./FileDownloadCard.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadCard.vue?vue&type=style&index=0&id=13c2ccec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2ccec",
  null
  
)

export default component.exports